import { FunctionComponent } from "react";
import { CarouselSwiperItemData } from "./constant";

interface CarouselSwiperItemProps extends CarouselSwiperItemData {
  showQuote?: boolean;
}

const CarouselSwiperItem: FunctionComponent<CarouselSwiperItemProps> = ({
  title,
  consolidatedInto,
  savingsDisplay,
  image,
  quote,
  showQuote = true,
}: CarouselSwiperItemProps) => {
  return (
    <>
      <div className="imageAndBannerContainer">
        <div className="banner banner__top fadeIn">
          <div className="banner__title medium bold">{title}</div>
          <div className="small">{consolidatedInto}</div>
        </div>
        <div className="banner banner__bottom fadeIn">
          <div className="banner__title medium bold">ADDITIONAL SAVINGS*</div>
          <h3>{savingsDisplay}</h3>
        </div>
        <div className="imageContainer fadeIn">{image}</div>
      </div>
      {showQuote && (
        <div className="quote fadeIn">
          <em className="light small">&quot;{quote}&quot;</em>
        </div>
      )}
    </>
  );
};
export default CarouselSwiperItem;
